// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  env: 'dev',
  hideConsole: false,
  production: false,
  applications: {
    fortify: {
      v2: 'https://devv2.fortify.lcptracker.net',
      api: 'https://devv2.fortify.lcptracker.net/api',
    },
  },
  authentication: {
    issuer: 'https://devv2.fortify.lcptracker.net',
    redirectUrl: `${window.location.origin}/login/success`,
    postLogoutRedirectUri: `${window.location.origin}`,
    clientId: 'ContractorSpa',
    responseType: 'code',
    scope: 'email theidservertokenapi openid profile theidserveradminapi rbsApi offline_access',
    silentRenewUrl: 'https://devv2.fortify.lcptracker.net/connect/token',
    renewTimeBeforeTokenExpiresValue: 300,
  },
  graphql: {
    gateway: {
      name: 'GatewayGraphQL',
      url: 'https://lcp-gateway-dev-appsvs.azurewebsites.net/graphql/',
    },
    contractor: {
      name: 'ContractorGraphQL',
      url: 'https://lcp-contractor-dev-appsvs.azurewebsites.net/graphql/',
    },
    project: {
      name: 'ProjectGraphQL',
      url: 'https://lcp-project-dev-appsvs.azurewebsites.net/graphql/',
    },
    rbs: {
      name: 'RBSGraphQL',
      url: 'https://lcp-rbs-dev-appsvs.azurewebsites.net/graphql/',
    },
    wageData: {
      name: 'WageGraphQL',
      url: 'https://lcp-wagedata-dev-appsvs.azurewebsites.net/graphql/',
    },
  },

  userPortalHost: 'https://dev.userportal.lcptracker.net',
  userPortalSso: 'https://dev.userportal.lcptracker.net/login/sso',
  smartClientURL: 'https://dev-apim.lcptracker.net/smartclientapi',
};

/*

 * For easier debugging in development mode, you can import the following file

 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.

 * This import should be commented out in production mode because it will have a negative impact

 * on performance if an error is thrown.

 */

// import 'zone.js/plugins/zone-error';
// Included with Angular CLI.Collapse
